module.exports = __webpack_public_path__ + "img/red-mic.98c3f496.svg";